import React from 'react';
import './WeChatShareModule.scss'

class WeChatShareModule extends React.Component {
	close = () => {
		this.props.close && this.props.close.onClose()
	}

	render() {
		const moduleBg = require('../../asstes/img/other/share-arrow.png')
		const noModuleBg = require('../../asstes/img/other/no-share-arrow.png')
		const {userCheckIn} = this.props

		return <div className="weChat-module-container" onClick={this.close}>
			<p className="prompt"></p>
			{
				userCheckIn ?
					<img className="share-guide-arrow" src={moduleBg} alt=""/> :
					<img className="share-guide-arrow" src={noModuleBg} alt=""/>
			}
		</div>
	}
}

export default WeChatShareModule;
